import React, { useEffect, useState, useRef, useLayoutEffect } from 'react'
import styles from './InvoiceModal.module.css'
import classNames from 'classnames'
import DeleteButton from '../../buttons/actions-button/DeleteButton'
import EditButton from '../../buttons/actions-button/EditButton'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import {
  fetchDetachCargo,
  fetchUpdateInvoice,
  setCurrentInvoice,
  setIsVisibleModalInvoice,
  setSelectedCargosForInvoice,
  clearSelectedCargosForInvoice,
  setVisibleDetachCargosModal,
  setVisibleDeleteCargosModal,
} from '../../../redux/reducers/invoices'
import {
  invoicesSelector,
  selectedCargosForInvoiceSelector,
} from '../../../redux/selectors/invoices-selector'
import { formatDateToDDMMYYYY } from '../../../utils/date'
import { canCurrentUserDeleteCargo } from '../../../utils/cargoDeletePermission'
import { getAmount, getItemCurrency } from '../../../utils/getAmount'
import {
  Cargo,
  returnCargoToStore,
  setCargosGroup,
  setCurrentCargo,
  setIsDisabledEdit,
  setIsVisibleDeleteModalCargo,
  setIsVisibleModalCargo,
  fetchDeleteCargoImage,
} from '../../../redux/reducers/cargos'
import DownloadComponent from '../../../pages/documents/accounts/DownloadComponent'
import { getCargoCounterpartyInfo } from '../cargo-side-modal/UnpaidCargoCard'
import { useClearBodyNoScrollClass } from '../../../hooks/use-clear-body-no-scroll-slass'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { getRole } from '../../../utils/getRole'

function InvoiceModal() {
  const dispatch = useDispatch<AppDispatch>()
  const { currentInvoice } = useSelector(invoicesSelector)
  const selectedCargos = useSelector(selectedCargosForInvoiceSelector)
  const [isVisibleDetachModal, setIsVisibleDetachModal] = useState(false)
  const [currentDetach, setCurrentDetach] = useState<Cargo | null>(null)
  const [isVisibleDeleteIconModal, setIsVisibleDeleteIconModal] =
    useState(false)
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState<number>(0)
  const [currentPhotoCargo, setCurrentPhotoCargo] = useState<Cargo | null>(null)
  useClearBodyNoScrollClass()
  const [date, setDate] = useState('')
  const [paidAt, setPaidAt] = useState('')
  const [note, setNote] = useState('')
  const textareaRefNote = useRef<HTMLTextAreaElement>(null)

  const [paidStatus, setPaidStatus] = useState(currentInvoice?.paid ?? 0)
  const [signed, setSigned] = useState<boolean>(false)

  const { isClient } = getRole()
  // Проверяем, является ли счет оплаченным для клиента
  const isPaidInvoice = currentInvoice?.paid === 1
  const isDisabledForClient = isClient && isPaidInvoice

  useEffect(() => {
    if (currentInvoice?.paid) setPaidStatus(currentInvoice.paid)
  }, [currentInvoice])

  useEffect(() => {
    if (currentInvoice?.signed) setSigned(Boolean(currentInvoice.signed))
  }, [currentInvoice])

  useEffect(() => {
    if (currentInvoice?.date) {
      const dateValue = currentInvoice.date.split('T')[0]
      setDate(dateValue)
    }
  }, [currentInvoice])

  useEffect(() => {
    if (currentInvoice?.paid_at) {
      const dateValue = currentInvoice.paid_at.split('T')[0]
      setPaidAt(dateValue)
    }
  }, [currentInvoice])

  useEffect(() => {
    if (currentInvoice?.note) {
      setNote(currentInvoice.note)
    } else {
      setNote('')
    }
  }, [currentInvoice])

  // Автоизменение высоты textarea для заметки
  useLayoutEffect(() => {
    if (textareaRefNote.current) {
      textareaRefNote.current.style.height = 'inherit'
      textareaRefNote.current.style.height = `${textareaRefNote.current.scrollHeight}px`
    }
  }, [note])

  // Очищаем выбранные грузы при закрытии модалки
  useEffect(() => {
    if (!currentInvoice) {
      dispatch(clearSelectedCargosForInvoice())
    }
  }, [currentInvoice, dispatch])

  // Очищаем выбранные грузы при закрытии модалки
  useEffect(() => {
    return () => {
      // Очищаем выбранные грузы при размонтировании компонента
      dispatch(clearSelectedCargosForInvoice())
    }
  }, [dispatch])

  const handleStatusChange = (e: any) => {
    const newStatus = parseInt(e.target.value)
    setPaidStatus(newStatus)
  }

  const handleSave = () => {
    const cargoIds = currentInvoice?.cargos?.map((item) => item.id) ?? []

    const params = {
      date,
      paid: paidStatus,
      signed,
      paidAt,
      note,
      selectedCargos: cargoIds,
    }

    dispatch(fetchUpdateInvoice(params))
  }

  const handleDetachModal = (item: Cargo) => {
    setCurrentDetach(item)
    setIsVisibleDetachModal(true)
  }

  const handleDeletePhoto = (cargo: Cargo, photoIndex: number) => {
    setCurrentPhotoCargo(cargo)
    setCurrentPhotoIndex(photoIndex)
    setIsVisibleDeleteIconModal(true)
  }

  const handleCargoSelect = (cargoId: number, checked: boolean) => {
    if (checked) {
      dispatch(setSelectedCargosForInvoice([...selectedCargos, cargoId]))
    } else {
      dispatch(
        setSelectedCargosForInvoice(
          selectedCargos.filter((id) => id !== cargoId)
        )
      )
    }
  }

  const handleClearSelection = () => {
    dispatch(clearSelectedCargosForInvoice())
  }

  const handleMassDetach = () => {
    if (selectedCargos.length === 0) return
    dispatch(setVisibleDetachCargosModal(true))
  }

  const handleDetach = () => {
    if (!currentDetach) return
    setIsVisibleDetachModal(false)
    dispatch(
      fetchDetachCargo({
        invoiceId: String(currentInvoice?.id),
        selectedCargos: [currentDetach.id],
      })
    ).then((res) => {
      //@ts-ignore
      if (!res.error) {
        dispatch(returnCargoToStore(currentDetach))
      }
    })
  }

  const handleConfirmDeletePhoto = () => {
    if (!currentPhotoCargo || currentPhotoCargo.images === undefined) return

    const photoToDelete = currentPhotoCargo.images[currentPhotoIndex]
    // if (!photoToDelete) return

    dispatch(
      fetchDeleteCargoImage({
        imageId: photoToDelete.id,
        cargoId: currentPhotoCargo.id,
      })
    ).then((res) => {
      //@ts-ignore
      if (!res.error) {
        // Обновляем текущий инвойс, убирая удаленное изображение
        if (currentInvoice) {
          const updatedCargos = currentInvoice.cargos.map((cargo) => {
            if (cargo.id === currentPhotoCargo.id) {
              return {
                ...cargo,
                images:
                  cargo.images?.filter(
                    (_, index) => index !== currentPhotoIndex
                  ) || [],
              }
            }
            return cargo
          })

          const updatedInvoice = {
            ...currentInvoice,
            cargos: updatedCargos,
          }

          dispatch(setCurrentInvoice(updatedInvoice))
        }

        setIsVisibleDeleteIconModal(false)
        setCurrentPhotoCargo(null)
        setCurrentPhotoIndex(0)
      }
    })
  }

  const handleMassDelete = () => {
    if (selectedCargos.length === 0) return
    dispatch(setVisibleDeleteCargosModal(true))
  }

  const DeleteModal = ({ title, onConfirm, onCancel }: any) => {
    return (
      <div style={{ display: 'block' }} className={styles.win}>
        <div className={styles.winContainer}>
          <div className={styles.winContent}>
            <div
              className={styles.close}
              onClick={() => setIsVisibleDetachModal(false)}
            >
              ×
            </div>
            <div className={styles.winContentFulltext}>
              <h4
                style={{ textAlign: 'center' }}
                className={classNames(styles.colorRed, styles.h4, 'mb-5')}
              >
                Вы уверены, что хотите открепить груз?
              </h4>
              {/* <p className={styles.p} style={{ textAlign: 'center' }}>
                {title !== 'Report' &&
                  `All reports related to this ${title.toLowerCase()} will remain available.`}
              </p> */}

              <div className="row mt-2">
                <div
                  className="col-12 col-sm-8 mt-1 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  <button
                    onClick={handleDetach}
                    className={`${styles.btn} d-block d-sm-inline-block`}
                  >
                    ДА, Я УВЕРЕН
                  </button>
                </div>
                <div
                  className="col-12 col-sm-4 mt-1 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  <div
                    onClick={() => setIsVisibleDetachModal(false)}
                    className={`${styles.btn} ${styles.btnSmall} ${styles.btnBlueOutline} d-block d-sm-inline-block`}
                  >
                    Отмена
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'block' }} className={styles.win}>
      <div className={styles.winContainer}>
        {isVisibleDetachModal && <DeleteModal />}

        <div className={styles.winContent}>
          <div
            onClick={() => {
              dispatch(setCurrentInvoice(null))
              dispatch(setIsVisibleModalInvoice(false))
              dispatch(setCurrentCargo(null))
              dispatch(setCargosGroup(null))
              dispatch(setIsDisabledEdit(false))
            }}
            className={styles.close}
          >
            ×
          </div>
          <div className={styles.winContentFulltext}>
            <div className="mb-3 pl-5 pr-5" style={{ textAlign: 'center' }}>
              <div className="mb-2">
                <b>{currentInvoice?.client?.entity_name}</b>
              </div>
              <h3 style={{ textAlign: 'center' }} className="mb-1">
                Счёт №{currentInvoice?.id}
              </h3>
              <div className="center">
                <span className={styles.small3}>На сумму:</span>

                <b className={styles.colorRed}>
                  {getAmount(currentInvoice?.sum ?? 0)}{' '}
                  {getItemCurrency(currentInvoice?.client.currency ?? '')}
                </b>
              </div>
            </div>

            <div
              className={classNames(
                'row align-items-center mb-2',
                styles.small
              )}
            >
              <div
                className="col-6 col-sm-4 mb-1"
                style={{ textAlign: 'left' }}
              >
                <span
                  style={{ width: '135px' }}
                  className={classNames(styles.reportDate)}
                  id="report_date_input_wrapper_invoice"
                >
                  <input
                    className={classNames(
                      styles.calendarInput,
                      styles.dateInput
                    )}
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    disabled={isClient || isDisabledForClient}
                  />
                </span>
              </div>

              <div className="col-6 col-sm-4 mb-1">
                <select
                  value={paidStatus}
                  onChange={handleStatusChange}
                  className="form-select"
                  disabled={isDisabledForClient}
                >
                  {isDisabledForClient ? (
                    <option value={1}>Оплачено</option>
                  ) : (
                    <>
                      <option value={0}>Не оплачен</option>
                      <option value={2}>На оплате</option>
                      {!isClient && <option value={1}>Оплачен</option>}
                    </>
                  )}
                </select>
              </div>

              <div className="col-6 col-sm mb-1" style={{ textAlign: 'left' }}>
                <input
                  type="checkbox"
                  name="signed"
                  id="signed"
                  checked={Boolean(signed)}
                  onChange={(e) => {
                    setSigned(e.target.checked)
                  }}
                  disabled={isClient || isDisabledForClient}
                />
                <label htmlFor="signed">Подписан</label>
              </div>
            </div>

            {String(paidStatus) === '1' && (
              <div
                className={classNames(
                  styles.small,
                  'row align-items-center mb-3'
                )}
              >
                <div
                  className="col-6 col-sm-4 offset-sm-4 mb-1"
                  style={{ textAlign: 'right' }}
                >
                  Дата оплаты:
                </div>
                <div
                  className="col-6 col-sm-4 mb-1"
                  style={{ textAlign: 'left' }}
                >
                  <span className="report-date">
                    <input
                      className={classNames(
                        styles.calendarInput,
                        styles.dateInput
                      )}
                      type="date"
                      value={paidAt}
                      onChange={(e) => setPaidAt(e.target.value)}
                      disabled={isClient || isDisabledForClient}
                    />
                  </span>
                </div>
              </div>
            )}

            {currentInvoice?.cargos.map((item) => (
              <div
                key={item.id}
                className={classNames(
                  styles.shipmentItem,
                  styles.bxShadowSmall,
                  styles.bgGray,
                  styles.border10,
                  styles.small2,
                  'pt-1 pb-1  mb-2'
                )}
              >
                <div className="row align-items-center ml-2 mr-2">
                  <div className="col-12 pl-1">
                    <div className="row align-items-center">
                      <div className="col-auto pr-0">
                        <input
                          className={styles.shipmentSelect}
                          onChange={(e) =>
                            handleCargoSelect(item.id, e.target.checked)
                          }
                          type="checkbox"
                          id={`shipment_${item.id}`}
                          checked={selectedCargos.includes(item.id)}
                          disabled={isDisabledForClient}
                        />
                        <label
                          className="d-inline-block"
                          htmlFor={`shipment_${item.id}`}
                        >
                          &nbsp;
                        </label>
                      </div>
                      <div className="col pl-0">
                        <div
                          className={styles.ellipsis2}
                          onClick={() => {
                            dispatch(setIsVisibleModalCargo(true))
                            dispatch(setCurrentCargo(item))
                            dispatch(setIsDisabledEdit(true))
                          }}
                        >
                          <b>{item.description}</b>
                        </div>
                      </div>
                      {/* ФОТКИ К ГРУЗУ: сначала кол-во, потом кнопка с иконкой (как в статике) */}
                      <div
                        className={classNames(
                          'col-auto pr-0',
                          styles.colorBlue
                        )}
                      >
                        {item.images?.length &&
                        Array.isArray(item.images) &&
                        item.images.length > 0 ? (
                          <span
                            className={classNames(
                              'd-inline-flex align-items-center',
                              styles.shipmentPhotosWrap
                            )}
                          >
                            <span
                              className={classNames(
                                'd-inline-block',
                                styles.small3
                              )}
                            >
                              {item.images.length}
                            </span>
                            <PhotoProvider
                              className={classNames(
                                styles.photoProvider,
                                styles.shipmentPhotoBtnWrap
                              )}
                            >
                              {item.images.map((photo: any, index: number) => (
                                <PhotoView
                                  key={photo.id}
                                  src={
                                    photo?.image?.lg || photo?.image?.original
                                  }
                                >
                                  {index === 0 ? (
                                    <span
                                      className={classNames(
                                        styles.btn,
                                        styles.btnBlueOutline,
                                        styles.btnSmall2,
                                        styles.btnIcon
                                      )}
                                    >
                                      <i
                                        className={classNames(
                                          styles.icon,
                                          styles.icon15,
                                          styles.iconPicture
                                        )}
                                      />
                                    </span>
                                  ) : (
                                    <img style={{ display: 'none' }} alt="" />
                                  )}
                                </PhotoView>
                              ))}
                            </PhotoProvider>
                          </span>
                        ) : (
                          <span className={classNames(styles.small3)} />
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={classNames(
                      styles.small2,
                      'col-12 col-sm pt-1 pb-1 pl-1 '
                    )}
                  >
                    <div className={styles.small3}>
                      <i
                        className={classNames(
                          styles.icon,
                          styles.iconRoute,
                          styles.icon10
                        )}
                      ></i>{' '}
                      {item?.report?.number || 'б/н'} &nbsp;{' '}
                      {item?.report?.departure && (
                        <span className={styles.colorGray}>
                          от {formatDateToDDMMYYYY(item?.report?.departure)}
                        </span>
                      )}
                    </div>

                    <div className={classNames(styles.small3, 'mb-1')}>
                      {!!item.has_tn && (
                        <span
                          className={classNames(
                            'd-inline-block pl-1 pr-1 mr-1',
                            styles.bgGreen,
                            styles.colorWhite,
                            styles.borderRadius5,
                            styles.small3
                          )}
                        >
                          <b>Т/Н</b>
                        </span>
                      )}
                      {getCargoCounterpartyInfo(item)}
                    </div>
                  </div>
                  <div
                    className="col-auto pl-1 pr-3"
                    style={{ textAlign: 'right' }}
                  >
                    <b className={classNames(styles.colorRed, styles.nowrap)}>
                      {getAmount(item.amount ?? 0)}{' '}
                      {getItemCurrency(currentInvoice.client.currency)}
                    </b>
                  </div>
                  <div
                    className="col col-sm-auto pl-1 pr-0"
                    style={{ textAlign: 'right' }}
                  >
                    <div className={styles.inlineActions}>
                      <EditButton
                        onClick={() => {
                          dispatch(setIsVisibleModalCargo(true))
                          dispatch(setCurrentCargo(item))
                          dispatch(setIsDisabledEdit(true))
                        }}
                      />
                      {!isClient && !isDisabledForClient && (
                        <React.Fragment>
                          <div
                            onClick={() => handleDetachModal(item)}
                            data-tooltip="Убрать доставку из счёта"
                            className={classNames(
                              styles.btn,
                              styles.btnSmall2,
                              styles.btnIcon,
                              styles.btnOutline,
                              styles.tooltipLeftCenter
                            )}
                          >
                            <i
                              className={classNames(
                                styles.icon,
                                styles.iconRemove
                              )}
                            />
                            <div className={classNames(styles.tooltipText)}>
                              Скачать путевой
                            </div>
                          </div>
                          {canCurrentUserDeleteCargo(item) && (
                            <DeleteButton
                              onClick={() => {
                                dispatch(setCurrentCargo(item))
                                dispatch(setIsVisibleDeleteModalCargo(true))
                              }}
                            />
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {!isClient && !isDisabledForClient && selectedCargos.length > 0 && (
              <div className="row mt-3">
                <div
                  className="col-12 jsDelSelected pb-3"
                  style={{ textAlign: 'right' }}
                >
                  <a
                    onClick={handleMassDetach}
                    className={classNames(
                      styles.colorRed,
                      styles.small2,
                      styles.clickable
                    )}
                    style={{ cursor: 'pointer' }}
                  >
                    Убрать из счёта ({selectedCargos.length})
                  </a>{' '}
                  &nbsp;
                  <a
                    onClick={handleMassDelete}
                    className={classNames(
                      styles.colorRed,
                      styles.small2,
                      styles.clickable
                    )}
                    style={{ cursor: 'pointer' }}
                  >
                    Удалить ({selectedCargos.length})
                  </a>{' '}
                  &nbsp;
                  <a
                    onClick={handleClearSelection}
                    className={classNames(styles.small2, styles.clickable)}
                    style={{ cursor: 'pointer' }}
                  >
                    Сбросить
                  </a>
                </div>
              </div>
            )}

            <div className="mb-3">
              <div className={classNames('mb-1 mt-3', styles.small2)}>
                Заметка
              </div>
              <textarea
                ref={textareaRefNote}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                className={styles.note}
                rows={2}
                placeholder="Введите заметку..."
                disabled={isClient || isDisabledForClient}
              />
            </div>
            <div className="row mt-3 d-none d-sm-flex">
              <div
                className="col-auto pr-0 mt-1 mb-1"
                style={{ textAlign: 'left' }}
              >
                <button
                  onClick={handleSave}
                  className={classNames(styles.btn, styles.btnSmall)}
                  disabled={isDisabledForClient}
                >
                  <i
                    className={classNames(styles.icon, styles.iconCheckWhite)}
                  ></i>{' '}
                  Сохранить
                </button>
              </div>
              <div
                className="col-auto pl-1 pr-1  mt-1 mb-1"
                style={{ textAlign: 'center' }}
              >
                {(currentInvoice?.pdf_url ||
                  currentInvoice?.pdf_with_stamp_url) && (
                  <DownloadComponent item={currentInvoice} iconText="PDF" menuAlign="start" />
                )}
              </div>
              <div className="col mt-1 mb-1" style={{ textAlign: 'right' }}>
                <div
                  onClick={() => {
                    dispatch(setCurrentInvoice(null))
                    dispatch(setIsVisibleModalInvoice(false))
                    dispatch(setCurrentCargo(null))
                    dispatch(setCargosGroup(null))
                    dispatch(setIsDisabledEdit(false))
                  }}
                  className={classNames(
                    styles.btn,
                    styles.btnSmall,
                    styles.btnBlueOutline
                  )}
                >
                  {isClient ? 'Закрыть' : 'Отмена'}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Фиксированная панель с кнопками для мобильных устройств */}
        <div className={classNames(styles.winBottomPanel, 'd-block d-sm-none')}>
          <div className="row align-items-center">
            <div className="col-5 pr-1" style={{ textAlign: 'left' }}>
              <button
                type="button"
                className={classNames(
                  styles.btn,
                  styles.btnSmall2,
                  styles.btnWide,
                  'd-block'
                )}
                onClick={handleSave}
                disabled={isDisabledForClient}
              >
                <i className={classNames(styles.icon, styles.iconCheckWhite)} />{' '}
                Сохранить
              </button>
            </div>
            {(currentInvoice?.pdf_url || currentInvoice?.pdf_with_stamp_url) && (
              <div className="col-auto px-1" style={{ textAlign: 'center' }}>
                <DownloadComponent
                  item={currentInvoice}
                  iconText="PDF"
                  menuAlign="center"
                />
              </div>
            )}
            <div className="col pl-0" style={{ textAlign: 'right' }}>
              <div
                className={classNames(
                  styles.btn,
                  styles.btnSmall2,
                  styles.btnWide,
                  styles.btnBlueOutline
                )}
                onClick={() => {
                  dispatch(setCurrentInvoice(null))
                  dispatch(setIsVisibleModalInvoice(false))
                  dispatch(setCurrentCargo(null))
                  dispatch(setCargosGroup(null))
                  dispatch(setIsDisabledEdit(false))
                }}
              >
                {isClient ? 'Закрыть' : 'Отмена'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceModal

// <div class="row mt-3 d-none d-sm-flex">

// 					<div class="col-12 jsDelSelected pb-3" align="right" style="display: none;">
// 						<a class="color-red small-2" href="#">Убрать из счёта</a> &nbsp;
// 						<a class="color-red small-2" >Удалить</a> &nbsp;
// 						<a class="small-2" href="javascript:UnselectShipments();">Сбросить</a>
// 					</div>

// 					<div class="col-auto pr-0 mt-1 mb-1" align="left">
// 						<div onclick="CloseWin('win_invoice_edit');" class="btn btn-small"><i class="icon icon-check-white"></i> Сохранить</div>
// 					</div>
// 					<div class="col-auto pl-1 pr-1  mt-1 mb-1" align="center">
// 						<div class="btn btn-small btn-blue"><i class="icon icon-download icon-white"></i> PDF</div>
// 					</div>
// 					<div class="col pl-0 mt-1 mb-1" align="right">
// 						<div onclick="CloseWin('win_invoice_edit');" class="btn btn-small btn-blue-outline">Отмена</div>
// 					</div>
// 				</div>
